export const defaultValues = {
	name: "",
	lastName: "",
	email: "",
	password: "",
	birthdate: "",	
	role:"user",
	viewed: [""],
};